import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, Typography, Grid, Card, CardActionArea, CardContent, Hidden, CardMedia} from '@material-ui/core';


const useStyles = makeStyles({
    card: {
        display: 'flex',
    },
    cardDetails: {
        flex: 1,
    },
    cardMedia: {
        width: 160,
    },
});


/**
 * This function is used to display some Cards, to give an eye on what we have in our app
 * @param props {object} : props, contains post information, as title, date and description
 * @return {*}
 * @constructor
 */
export default function FeaturedPost(props) {
    const classes = useStyles();
    const {post} = props;

    return (
        <Grid item xs={12} md={6}>
            <CardActionArea component={props.auth ? "p" : "a"} href={props.auth ? null :  "/inscription"}>
                <Card className={classes.card}>
                    <div className={classes.cardDetails}>
                        <CardContent>
                            <Typography component="h2" variant="h5">
                                {post.title}
                            </Typography>
                            <Typography variant="subtitle1" color="textSecondary">
                                {post.date}
                            </Typography>
                            <Typography variant="subtitle1" paragraph>
                                {post.description}
                            </Typography>
                            {!props.auth && <Typography variant="subtitle1" color="primary">
                                Inscrivez - vous...
                            </Typography>}
                        </CardContent>
                    </div>
                    <Hidden xsDown>
                        <CardMedia className={classes.cardMedia} image={post.image} title={post.imageTitle}/>
                    </Hidden>
                </Card>
            </CardActionArea>
        </Grid>
    );
}


FeaturedPost.propTypes = {
    post: PropTypes.object,
};
